// const urls = 'http://localhost:5000/api' // Local
const urls = 'https://chatine-backend.vercel.app/api' // Production

export default urls
